<!--美育浸润-->
<template>
    <div class="guide-nav-content" >
        <div class="guide-ext-container" v-show="videoMode==='beautyEdu'">
            <div class="museum-title-container">
                <div class="l-museum-title-container">
                    <div class="l-t-museum-title-container">美育浸润</div>
                    <div class="l-b-museum-title-container">十四个系列视频资源</div>
                </div>
                <div class="r-museum-title-container">
                    <div class="back-btn-container" @click="backReadMuseum" >⇦返回</div>
                </div>
            </div>

            <div class="museum-item-container">
                <div class="labor-museum-item-line-container">
                    <div class="museum-item-top-container">
                        <div class="labor-museum-item-top">
                            <div class="museum-item-content">
                                <div class="museum-item-40 mf1">诗词天地</div>
                                <div class="museum-item-20 labor-mf2">古诗吟唱  诗词诵读  诗词鉴赏</div>
                                <div class="museum-item-40 dis-align">
                                    <div class="resource-btn" @click = "viewHumVideo('诗词天地','1')">查看资源</div>
                                </div>
                            </div>
                        </div>
                    </div>
                    <div class="museum-item-top-container">
                        <div class="labor-museum-item-top">
                            <div class="museum-item-content">
                                <div class="museum-item-40 mf1">经典悦读</div>
                                <div class="museum-item-20 labor-mf2">和你读诗  诗文素养  成语典故</div>
                                <div class="museum-item-40 dis-align">
                                    <div class="resource-btn" @click="viewHumVideo('经典悦读','2')">查看资源</div>
                                </div>
                            </div>
                        </div>
                    </div>
                    <div class="museum-item-top-container">
                        <div class="labor-museum-item-top">
                            <div class="museum-item-content">
                                <div class="museum-item-40 mf1">经典悦读</div>
                                <div class="museum-item-20 labor-mf2">经典美文  德育名篇  经典童谣</div>
                                <div class="museum-item-40 dis-align">
                                    <div class="resource-btn" @click="viewHumVideo('经典悦读','3')">查看资源</div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
                <div class="labor-museum-item-line-container">
                    <div class="museum-item-top-container">
                        <div class="labor-museum-item-top">
                            <div class="museum-item-content">
                                <div class="museum-item-40 mf1">家国铸魂</div>
                                <div class="museum-item-20 labor-mf2">伟人诗词  中华美德  英雄模范 爱我中华歌曲  世界名曲</div>
                                <div class="museum-item-40 dis-align">
                                    <div class="resource-btn" @click="viewHumVideo('家国铸魂','4')">查看资源</div>
                                </div>
                            </div>
                        </div>
                    </div>
                    <div class="museum-item-top-container">

                    </div>
                    <div class="museum-item-top-container">

                    </div>
                </div>
            </div>

        </div>
        <!--系列视频列表-->
        <div class="detail-mode" v-show="videoMode==='beautyEduInfo'">
            <beauty-videos :module-key="this.moduleKey"
                           :module-name="moduleName"
                           :mark-info="this.markInfo"
                           @back-model-page="backModelPage"/>
        </div>
    </div>
</template>

<script>
import {serviceUrl} from "@/utils/global";
import beautyVideos from "@/components/newMuseum/read/beautyVideos.vue";

export default {
    name: "beautyEdu",
    components: {beautyVideos},
    data() {
        return {
            showMode:'beautyEdu',
            serviceUrl,
            moduleName:'视频列表',
            moduleKey:'1',
            markInfo:'',
            videoMode:"beautyEdu"
        }
    },
    computed: {},
    props:{
        markInfo:{
            type: String,
            default:null
        },
    },
    watch: {
        markInfo(newValue,oldValue){
            this.showMode = 'beautyEdu';
        },

    },
    created() {
    },
    mounted(){},
    methods: {
        changeModel(item){
            this.showMode = item
            this.$emit('change-mode',this.showMode, 8);
        },
        backReadMuseum(){
            this.videoMode = 'beautyEdu'
            this.$emit('back-read-museum', "homePage");
        },
        viewHumVideo(name,key){
            this.moduleName = name;
            this.moduleKey = key;
            this.markInfo = new Date();
            this.showMode = 'beautyEduInfo'
            this.videoMode = 'beautyEduInfo'
        },
        backModelPage(val){
            this.videoMode = 'beautyEdu'
            this.showMode = val;
        }
    }
}

</script>

<style scoped>
.guide-nav-content{
    width: 100%;
    height: auto;
}
.guide-ext-container{
    width: 100%;
    height: calc(100vh - 174px);
    background: #ffffff;
    border-radius: 16px;
    padding: 20px 0;
    box-sizing: border-box;
    display: flex;
    flex-direction: column;
}

.museum-title-container{
    flex-shrink: 0;
    width: 100%;
    display: flex;
    justify-content: space-between;
    align-items: center;
    margin-bottom: 14px;
}
.l-museum-title-container{
    display: flex;
    flex-direction: column;
    gap: 4px;
}
.l-t-museum-title-container{
    font-weight: bold;
    color: #ff7f2e;
    font-size: 18px;
    line-height: 1.4;
}
.l-b-museum-title-container{
    color: #9a9a9a;
    font-size: 14px;
}
.r-museum-title-container{
    display: flex;
    align-items: center;
}
.back-btn-container{
    height: 32px;
    padding: 0 14px;
    background: #ff7f2e;
    color: #fff;
    line-height: 32px;
    text-align: center;
    font-size: 14px;
    border-radius: 6px;
    cursor: pointer;
}

.museum-item-container{
    flex: 1;
    min-height: 0;
    overflow-y: auto;
    padding: 0;
    display: flex;
    flex-direction: column;
    gap: 20px;
    padding: 0 28px ;
    box-sizing: border-box;
}
.labor-museum-item-line-container{
    flex-shrink: 0;
    width: 100%;
    height: 45%;
    display: flex;
    gap: 20px;
}
.museum-item-top-container{
    width: calc((100% - 40px) / 3);
    height: 100%;
    display: flex;
    align-items: center;
    justify-items: center;
}
.labor-museum-item-top{
    width: 100%;
    height: 85%;
    border-left: 5px solid #ff7f2e;
    box-shadow: inset 0 0 2px rgba(0,0,0,0.22);
    //box-shadow: var(--el-box-shadow-light);
    cursor: pointer;
    display: flex;
    align-items: center;
    justify-content: center;
    box-sizing: border-box;
}
.museum-item-content{
    width: 90%;
    height: 80%;
}
.museum-item-40{
    width: 100%;
    height: 40%;
}
.mf1{
    color: #ff7f2e;
    //font-size: 16px;
    font-weight: bold;
    display: flex;
    align-items: center;
    font-size: clamp(16px, 12cqh, 18px);
}
.labor-mf2{
    color: #9a9a9a;
    font-size: 13px;
}

.museum-item-20{
    width: 100%;
    height: 20%;
}
.resource-btn{
    width: 100%;
    height: 70%;
    background: #ff7f2e;
    color: #fff;
    font-size: 15px;
    font-weight: 700;
    border-radius: 6px;
    /* 核心居中代码 */
    display: flex;
    /* 水平居中 */
    justify-content: center;
    /* 垂直居中 */
    align-items: center;
    cursor: pointer;
}
.dis-align{
    display: flex;
    justify-items: center;
    align-items: center;
}





.detail-mode{
    width: 100%;
    height: auto;
}
</style>